<template>
	<div class="menu">
		<dl :class="{menu_ico_dl : menuID == 3}">
				<dd  v-for="(item,index) in menus" :key="index" @click="navTo(item,index)" 
				:class="{ cur : item.id == curIDprop }">
					{{item.name}}
				</dd>
		</dl>
	</div>
</template>

<script>
	export default {
	  name: 'hmenu',
		props: ['menuID','curID'],
		data(){
			return{
				menuIDprop :'',
				curIDprop:0,
				showimage:false,
				menus:[],
				activeIndex:0,
				childId2:''
			}
		},
		created(){
			this.menuIDprop = this.menuID;
			this.curIDprop = this.curID;
			this.res_menu(this.menuIDprop)
		},
		methods:{
			res_menu(e){
				this.axios.get('/api/menus/parentNumber?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.menus = response.data.reslut;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			navTo(item,index){
				this.curIDprop = item.id;
				if(item.id == 50 || item.id == 51){
					this.$router.push({
						// path:this.$route.path.slice(0,8)+ this.menuIDprop + item.url,
						path:'/slider/'+ 2 +'/er?category_id='+item.id,
						query:{
							category_id:item.id
						}
					})
				}else{
					this.$router.push({
						path:this.$route.path.slice(0,8)+ this.menuIDprop + item.url,
						query:{
							category_id:item.id
						}
					})
				}
			}
		},
		watch :{
			'menuID' (to, from) {
					// 对路由变化作出响应...
					console.log('menuIDto',to)
					console.log('menuIDf',from)
					this.menus = []
					this.menuIDprop = to;
					this.res_menu(this.menuIDprop);

			},
			'curID' (to, from) {
					// 对路由变化作出响应...
					this.curIDprop = to;
			
			}
		},
		mounted() {
		}
	}
</script>

<style>
</style>